// @flow

import { combineReducers } from 'redux';
import {
  GET_SETTINGS,
  GET_SETTINGS_SUCCESS,
  GET_SETTINGS_FAILED,
} from './constants';
import type {
  StartFetchSettings,
  ReceivedSettings,
  FailedSettings,
} from './actions';
import { initialState } from './state';
import type { FlatError } from '../../helpers/flattenError';

const fetching = (
  state: boolean = initialState.fetching,
  action: StartFetchSettings | ReceivedSettings | FailedSettings,
): boolean => {
  switch (action.type) {
    case GET_SETTINGS:
      return true;
    case GET_SETTINGS_SUCCESS:
    case GET_SETTINGS_FAILED:
      return false;
    default:
      return state;
  }
};

const fetched = (
  state: boolean = initialState.fetched,
  action: StartFetchSettings | ReceivedSettings | FailedSettings,
): boolean => {
  switch (action.type) {
    case GET_SETTINGS:
      return false;
    case GET_SETTINGS_SUCCESS:
      return true;
    default:
      return state;
  }
};

const error = (
  state: ?FlatError = initialState.error,
  action: StartFetchSettings | ReceivedSettings | FailedSettings,
): ?FlatError => {
  switch (action.type) {
    case GET_SETTINGS:
      return null;
    case GET_SETTINGS_FAILED:
      return action.payload;
    default:
      return state;
  }
};

export default combineReducers<Object, Object>({
  fetching,
  fetched,
  error,
});
